import { Controller } from 'stimulus'
import * as h from 'lib/helpers'

export default class Groups_ShowController extends Controller {
  static targets = ['content']

  refreshChangeableHtml() {
    this.refreshCurrentTab()
    this.fetchGroupDetailsArea()
  }

  refreshCurrentTab() {
    h.callStimulusAction('.model-show-container', 'tab', 'refreshCurrentTab')
  }

  fetchGroupDetailsArea() {
    h.callStimulusAction('.model-show-details-area', 'refresh-content', 'refreshContent')
  }

  get _objectId() {
    return this.data.get('object-id')
  }
}
